import { render, staticRenderFns } from "./addRootNodeBooks.vue?vue&type=template&id=500054b7&scoped=true"
import script from "./addRootNodeBooks.vue?vue&type=script&lang=js"
export * from "./addRootNodeBooks.vue?vue&type=script&lang=js"
import style0 from "./addRootNodeBooks.vue?vue&type=style&index=0&id=500054b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500054b7",
  null
  
)

export default component.exports